import React from "react";
import { Box, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CallIcon from "@mui/icons-material/CallOutlined";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import { mapRedirection} from "../../api/Redirection";

const Contact = () => {
  return (
    <Box sx={styles.additionalContainer}>
      <Box sx={styles.whiteBox}>
        <Typography sx={styles.addressTitle}>Address</Typography>
        <Box sx={styles.addressContainer}>
          <Typography sx={styles.addressLineBold}>The Farm Stories</Typography>
          <Typography sx={styles.addressLineLight}>
            Plot no 27, 28 & 29 ,Near Sai baba temple, <br /> Seegekote village, Shivanahalli post,<br />Kanakpura, Karnataka 562117
          </Typography>
        </Box>
        <Box sx={styles.getDirectionContainer}>
          <Typography
            sx={styles.getDirectionText}
            onClick={() => window.open(mapRedirection)}
          >
            GET DIRECTION
          </Typography>
          <ArrowForwardIcon sx={styles.arrowIcon} />
        </Box>
        <Typography sx={styles.howToGetHereTitle}>How to get here</Typography>
        <Typography sx={styles.howToGetHereText}>
          To reach the farm stories, continue onward journey through the kanakpura bypass road towards malavalli for 4kms and take a left turn showing board seegekote, continue until you reach the village and take left near flag pole post and continue till dead end and take right, just after 100mtr take left on cement road and continue for 300mtrs to reach the main gate on to your right.
        </Typography>
        <Typography sx={styles.connectTitle}>Let's Connect</Typography>
        <Box sx={styles.callContainer}>
          <CallIcon sx={styles.callIcon} />
          <Typography sx={styles.callText}>CALL</Typography>
        </Box>
        <Typography sx={styles.contactNumber}>
          +91 89717 13741 | +91 96202 32209
        </Typography>
        <Box sx={styles.callContainer}>
          <EmailIcon sx={styles.callIcon} />
          <Typography sx={styles.callText}>EMAIL</Typography>
        </Box>
        <Typography sx={styles.contactNumber}>
          enquiry@farmstories.in
        </Typography>
      </Box>
    </Box>
  );
};

const styles = {
  additionalContainer: {
    width: "100%",
    maxWidth: "100%",
    minWidth: "340px",
    height: { xs: "auto", md: "auto" },
    backgroundColor: "#F7EEE6",
    display: "flex",
    justifyContent: "center",
    alignItems: { xs: "flex-end", md: "center" },
    paddingTop: { xs: "120px", md: "120px" },
  },
  whiteBox: {
    position: "relative",
    width: { xs: "90%", md: "724px" },
    height: { xs: "auto", md: "786px" },
    padding: { xs: "24px", md: "32px" },
    backgroundColor: "#FFFFFF",
    borderRadius: "540px 540px 0 0",
    boxShadow: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    margin: "0 10px",
  },

  addressTitle: {
    fontFamily: "ZapfHumnst BT",
    fontSize: { xs: "24px", md: "32px" },
    fontWeight: "400",
    lineHeight: "39.61px",
    letterSpacing: "0.05em",
    marginTop: { xs: "20px", md: "60px" },
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },
  addressContainer: {
    marginBottom: "20px",
    textAlign: "center",
  },
  addressLineBold: {
    fontFamily: "Sora",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    textAlign: "center",
    color: "#886F58",
  },
  addressLineLight: {
    fontFamily: "Sora",
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "24px",
    textAlign: "center",
    color: "#886F58",
  },
  getDirectionContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
  },
  getDirectionText: {
    fontFamily: "Sora",
    fontSize: "15px",
    fontWeight: "400",
    lineHeight: "36px",
    letterSpacing: "0.01em",
    textAlign: "left",
    color: "#B8772A",
  },
  arrowIcon: {
    transform: "rotate(305deg)",
    color: "#B8772A",
  },
  howToGetHereTitle: {
    fontSize: { xs: "24px", md: "32px" },
    fontFamily: "ZapfHumnst BT",
    fontWeight: "400",
    lineHeight: "39.61px",
    letterSpacing: "0.05em",
    textAlign: "left",
    marginTop: "20px",
  },
  howToGetHereText: {
    width: { xs: "300px", sm: "650px" },
    fontFamily: "Sora",
    fontSize: { xs: "12px", md: "16px" },
    fontWeight: "300",
    lineHeight: { xs: "20px", md: "24px" },
    textAlign: "center",
    marginTop: "16px",
    color: "#886F58",
    maxWidth: { xs: "100%", md: "680px" },
  },
  connectTitle: {
    fontSize: { xs: "24px", md: "32px" },
    fontFamily: "ZapfHumnst BT",
    fontWeight: "400",
    lineHeight: "39.61px",
    letterSpacing: "0.05em",
    textAlign: "left",
    marginTop: "54px",
    marginBottom: "20px",
  },
  callContainer: {
    width: "296px",
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    // marginBottom: "5px",
  },
  LanguageOutlinedIcon: {
    color: "#886F58"
  },
  follow: {
    display: "flex",
    fontFamily: "Sora",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "36px",
    textAlign: "center",
    letterSpacing: "0.01em",
    color: "#886F58",
  },
  media: {
    display: "flex",
    marginBottom: "5px"
  },
  InstagramIcon: {
    padding: { xs: "5px", md: "5px" },
    color: "#886F58",
    width: "25px",
    height: "25px",
    marginBottom: "25px"
  },
  FacebookIcon: {
    padding: { xs: "5px", md: "5px" },
    color: "#886F58",
    width: "25px",
    height: "25px",
    marginBottom: "25px"
  },
  YouTubeIcon: {
    padding: { xs: "5px", md: "5px" },
    color: "#886F58",
    width: "25px",
    height: "25px",
    marginBottom: "25px"
  },
  callIcon: {
    width: "18px",
    height: "18px",
    color: "#886F58",
  },
  callText: {
    fontFamily: "Sora",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "36px",
    textAlign: "left",
    letterSpacing: "0.01em",
    color: "#886F58",
  },
  contactNumber: {
    fontFamily: "Sora",
    fontSize: { xs: "13px", md: "16px" },
    fontWeight: "300",
    lineHeight: "24px",
    textAlign: "center",
    color: "#886F58",
    marginTop: "-10px",
    // marginBottom: "30px",
  },
};

export default Contact;
